import { render } from "./TransferenciasDialog.vue?vue&type=template&id=67083af1"
import script from "./TransferenciasDialog.vue?vue&type=script&lang=js"
export * from "./TransferenciasDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__